
import { Movie } from './types';

export const MOCK_MOVIES: Movie[] = [
  {
    id: '1',
    title: 'Bluey',
    posterUrl: 'https://picsum.photos/seed/bluey/400/600',
    year: 2018,
    rating: 'TV-Y',
    platforms: ['Disney+', 'ABC iView'],
    safetyMatrix: { thematicWeight: 2, sensoryLoad: 3, dialogueCheck: 1, visualViolence: 1 },
    criticNote: "Ideal for toddlers. No intense music or dark colors. Gentle life lessons without any threat of peril.",
    genre: ['Animation', 'Family'],
    // Fix: Added missing contentType property required by Movie type
    contentType: 'tv'
  },
  {
    id: '2',
    title: 'Spider-Man: Into the Spider-Verse',
    posterUrl: 'https://picsum.photos/seed/spiderverse/400/600',
    year: 2018,
    rating: 'PG',
    platforms: ['Netflix', 'Disney+'],
    safetyMatrix: { thematicWeight: 5, sensoryLoad: 9, dialogueCheck: 3, visualViolence: 4 },
    criticNote: "High sensory load due to vibrant, flashing animation styles. Mild thematic weight regarding loss of family.",
    genre: ['Action', 'Superhero'],
    // Fix: Added missing contentType property required by Movie type
    contentType: 'movie'
  },
  {
    id: '3',
    title: 'The Lion King',
    posterUrl: 'https://picsum.photos/seed/lionking/400/600',
    year: 1994,
    rating: 'G',
    platforms: ['Disney+'],
    safetyMatrix: { thematicWeight: 8, sensoryLoad: 6, dialogueCheck: 2, visualViolence: 5 },
    criticNote: "Classic G-rating, but carries heavy thematic weight regarding parental loss. High visual violence during the stampede.",
    genre: ['Animation', 'Musical'],
    // Fix: Added missing contentType property required by Movie type
    contentType: 'movie'
  },
  {
    id: '4',
    title: 'Shrek',
    posterUrl: 'https://picsum.photos/seed/shrek/400/600',
    year: 2001,
    rating: 'PG',
    platforms: ['Max', 'Peacock'],
    safetyMatrix: { thematicWeight: 4, sensoryLoad: 5, dialogueCheck: 7, visualViolence: 3 },
    criticNote: "Heavy on adult double-entendres. Safe for kids visually, but dialogue may require some explanation.",
    genre: ['Animation', 'Comedy'],
    // Fix: Added missing contentType property required by Movie type
    contentType: 'movie'
  },
  {
    id: '5',
    title: 'Kiki\'s Delivery Service',
    posterUrl: 'https://picsum.photos/seed/kiki/400/600',
    year: 1989,
    rating: 'G',
    platforms: ['Max', 'Netflix'],
    safetyMatrix: { thematicWeight: 3, sensoryLoad: 2, dialogueCheck: 1, visualViolence: 1 },
    criticNote: "Pure comfort. Low sensory load with beautiful, calm visuals. Perfect for relaxing with young children.",
    genre: ['Anime', 'Fantasy'],
    // Fix: Added missing contentType property required by Movie type
    contentType: 'movie'
  },
  {
    id: '6',
    title: 'How to Train Your Dragon',
    posterUrl: 'https://picsum.photos/seed/dragon/400/600',
    year: 2010,
    rating: 'PG',
    platforms: ['Netflix', 'Disney+'],
    safetyMatrix: { thematicWeight: 6, sensoryLoad: 7, dialogueCheck: 2, visualViolence: 6 },
    criticNote: "Includes realistic visual violence (dragons fighting) and emotional moments about father-son dynamics.",
    genre: ['Action', 'Fantasy'],
    // Fix: Added missing contentType property required by Movie type
    contentType: 'movie'
  }
];
